import { render } from "./PremiumPayment.vue?vue&type=template&id=235603ad&scoped=true"
import script from "./PremiumPayment.vue?vue&type=script&lang=js"
export * from "./PremiumPayment.vue?vue&type=script&lang=js"

import "./PremiumPayment.vue?vue&type=style&index=0&id=235603ad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235603ad"]])

export default __exports__